import { render, staticRenderFns } from "./DesignBuild.vue?vue&type=template&id=516a8841"
import script from "./DesignBuild.vue?vue&type=script&lang=js"
export * from "./DesignBuild.vue?vue&type=script&lang=js"
import style0 from "./DesignBuild.vue?vue&type=style&index=0&id=516a8841&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports